import {
  Component,
  ElementRef,
  EnvironmentInjector,
  Input,
  OnInit,
  SimpleChange,
  SimpleChanges,
  ViewEncapsulation,
  runInInjectionContext,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationDialogComponent } from "src/app/confirmation-dialog/confirmation-dialog.component";
import * as M from "materialize-css/dist/js/materialize";
import { ProjectService } from "src/app/Services/project.service";
import {
  AngularFireDatabase,
  AngularFireList,
} from "@angular/fire/compat/database";
import { map } from "rxjs/operators";
import * as _ from "lodash";
import { SharedService } from "src/app/Services/sharedService";
import { BehaviorSubject, Subscription } from "rxjs";
import { MessagingServiceService } from "src/app/Services/messaging-service.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl } from "@angular/forms";
import { CustomTimeAgoPipe } from "src/app/time-ago.pipe";
import { Sort } from "@angular/material/sort";
import { version } from "process";
import { ScreenshotTimeService } from "src/app/Services/screenshot-time.service";
import { TourConfigService } from "src/app/Services/tour-config.service";
import { DummyDataService } from "src/app/Services/dummy-data.service";
import { Employee } from "src/app/interface/employee";
import { TokenEncryptionService } from "src/app/Services/token-encryption.service";
import moment from "moment";

class User {
  id: string;
  email: string;
  ssRequest: boolean;
  scRequestStart: boolean;
  scRequestStop: boolean;
  status: string;
  time: string;
  isreceive: boolean;
}
@Component({
  selector: "app-team-member-list",
  templateUrl: "./team-member-list.component.html",
  styleUrls: ["./team-member-list.component.css"],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TeamMemberListComponent implements OnInit {
  loading = true;
  @Input() groupList: any;
  statusLoad: boolean = true;
  selectedManagr = "Manager";
  roleFormControl = new FormControl('Manager');
  selectedTeamManagers: any = [];
  selectedAllTeam: any = [];
  selectedTeamDevelopers: any = [];
  selectedTeamLeaders: any = [];
  isUserEditable: any;
  editUserId: any;
  _usersList: any;
  _teamMembers: any;
  _teamMemberListOnMode;
  private dbPath: string | null = null;
  usersRef: AngularFireList<User> = null;
  activeSort: Sort; // Store current sort state

  tabIndex: any;
  historyTabs: any = 0;
  serverMassageSubject: BehaviorSubject<any>;
  roleFilter = false;
  userDataSubscription: Subscription;
  currentData;
  @Input()
  get teamData() {
    this.loading = true;
    return this._teamMembers;
  }
  set teamData(team: any) {
    if (team.length != 0) {
      this.loading = true;
      if (!this._usersList) {
        this._projectService.getUserList(0, 0).subscribe(async (data: any) => {
          let userData: any = Array.isArray(data) ? data : [];
          if (
            userData.length === 0 &&
            (await this._dummyDataService.shouldUseLegacySampleFallback(true))
          ) {
            const isShowDemoData = await this._dummyDataService.checkIsAvailableDemoData<Employee[]>('EmployeeList');
            if (isShowDemoData.status && isShowDemoData.data) {
              userData = isShowDemoData.data;
            }
          } else {
            this._dummyDataService.setDemoDataVisible(false);
          }
          const companyId = this.tokenEncryptionService.getEncryptedItem<any>('logedInUser')?.company_id;
          this.screenshotTime.getShiftTimezoneForCompany(companyId).subscribe((tz) => {
            data.forEach((developer: any) => {
              if (developer.meta.last_screenshot) {
                developer.meta.last_screenshot = this.screenshotTime.formatDisplayLocal(
                  developer.meta.last_screenshot,
                  tz
                );
              }
              developer.meta.last_ss = developer.meta.last_screenshot;
            });

            void (async () => {
              if (userData && userData.length > 0) {
                if (userData[0].selectedTeam == null || userData[0].selectedTeam == undefined) {
                  userData = await this._sharedService.assignTeamsAccordingList(userData, this.groupList);
                }
              }

              this._projectService.getUser().subscribe((item) => {
                this.tokenEncryptionService.setEncryptedItem('user', item);
                let isExpired = this._sharedService.checkPlanExpired(item)
                if (isExpired) {
                  return this.router.parseUrl('/plan-expired');
                }
                if (!userData.find(u => u.id === item.id)) {
                  userData.push(item);
                }
                this.getEmployeeIdOnTeamSelect(team.meta, userData);
                this.onSelectUserMode({ index: this.historyTabs });
              });
            })();
          });

        });
        this.loading = false;
      } else {
        this.loading = true;
        this.getEmployeeIdOnTeamSelect(team.meta);
        this.onSelectUserMode({ index: this.historyTabs });
        this.loading = false;
      }

      this._teamMembers = team;
    }

    if (!this.roleFormControl.value) {
      this.roleFormControl.setValue('All');
    }
    if (team.length == 0) {
      this._teamMemberListOnMode = [];
      this._teamMembers = [];
    }
    this.setStatus();
  }

  constructor(
    private _projectService: ProjectService,
    private _sharedService: SharedService,
    private db: AngularFireDatabase,
    private _messagingService: MessagingServiceService,
    private router: Router,
    private customtimeAgoPipe: CustomTimeAgoPipe,
    private screenshotTime: ScreenshotTimeService,
    private _dummyDataService: DummyDataService,
    private dialog: MatDialog,
    private tokenEncryptionService: TokenEncryptionService,
    private injector: EnvironmentInjector,
    private route: ActivatedRoute
  ) {
    // Listen for dbPath updates
    this._projectService.isFirebaseRefresh.subscribe((newDbPath: any) => {
      if (newDbPath && newDbPath.data) {
        this.dbPath = newDbPath.data;
        console.log('TeamMemberList: dbPath updated to:', this.dbPath);
        // Re-initialize Firebase reference if needed
        if (this.usersRef) {
          this.usersRef = runInInjectionContext(this.injector, () => this.db.list(this.dbPath));
        }
        // Refresh status if we have team data
        if (this._teamMemberListOnMode && this._teamMemberListOnMode.length > 0) {
          this.setStatus();
        }
      }
    });

    this.dbPath = this.tokenEncryptionService.getEncryptedItem<string>('dbPath') as string;

    if (this.router.url == '/teams') {
      this.roleFilter = true;
    } else {
      this.roleFilter = false;
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const selectedRole = params['selectedRole'];
      if (selectedRole) {
        if (this.roleFormControl.value !== selectedRole) {
           this.roleFormControl.setValue(selectedRole, { emitEvent: false });
           this.selectedManagr = selectedRole;
        }
        let roleKey = 'All';
        if (selectedRole === 'Manager') roleKey = 'manager';
        else if (selectedRole === 'Team Leader') roleKey = 'leaders';
        else if (selectedRole === 'Developer') roleKey = 'developer';
        this.getRoleMembers(roleKey);
      } else {
        if (this.roleFormControl.value !== 'All') {
           this.roleFormControl.setValue('All', { emitEvent: false });
           this.selectedManagr = 'All';
        }
        this.getRoleMembers('All');
      }
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.groupList && changes.groupList.currentValue && changes.groupList.currentValue.length != 0) {
      if (this._usersList && this._usersList.length > 0) {
        this._usersList = await this._sharedService.assignTeamsAccordingList(this._usersList, changes.groupList.currentValue);
      }
    }
  }

  openUserModal(data: any) {
    this.isUserEditable = data.isEdit;
    this.editUserId = data.userId;
    let instance = M.Modal.init(data.eleRef);
    instance.open();
  }

  openTeamEditModal(elementRef: ElementRef) {
    this._sharedService.teamModalinstance = M.Modal.init(elementRef);
    this._sharedService.teamModalinstance.open();
  }

  deleteDialog() {
    let dialogComponent = this.dialog.open(ConfirmationDialogComponent, {
      width: "400px",
      height: "170px",
    });
    dialogComponent.afterClosed().subscribe((result) => {
    });
  }

  onSelectUserMode(mode: any) {
    this.historyTabs = mode.index;
    switch (mode.index) {
      case 0:
        this._teamMemberListOnMode = this.selectedAllTeam;
        this.setStatus();
        break;
      case 1:
        this._teamMemberListOnMode = this.selectedTeamManagers;
        break;
      case 2:
        this._teamMemberListOnMode = this.selectedTeamLeaders;
        break;
      case 3:
        this._teamMemberListOnMode = this.selectedTeamDevelopers;
        break;
    }

    // Re-apply sort if active
    if (this.activeSort && this.activeSort.active && this.activeSort.direction) {
      this.sortData(this.activeSort);
    }
  }

  ngOnDestroy() {
    if (this.userDataSubscription) {
      this.userDataSubscription.unsubscribe();
    }
    this._messagingService.resetData()
  }

  setStatus() {
    // Ensure dbPath exists before proceeding
    if (!this.dbPath) {
      console.warn('dbPath not set, cannot initialize Firebase reference');
      return;
    }

    this.usersRef = runInInjectionContext(this.injector, () => this.db.list(this.dbPath));
    this.statusLoad = true;

    // Unsubscribe from previous subscription if exists
    if (this.userDataSubscription) {
      this.userDataSubscription.unsubscribe();
    }

    this.userDataSubscription = this._messagingService.getUserData().subscribe((users) => {
      this.loading = true;
      let sortFieldChanged = false;

      users.forEach((user) => {
        if (this._teamMemberListOnMode) {
          // Store old sort value before update (from the currently displayed list)
          let oldSortValue = null;
          if (this.activeSort && this.activeSort.active && this.activeSort.direction) {
            const currentUser = this._teamMemberListOnMode.find((u: any) => u.id === user.id);
            if (currentUser) {
              oldSortValue = this.getSortValueFromUser(currentUser);
            }
          }

          // Update all lists
          this.updateUserInList(user, this.selectedAllTeam);
          this.updateUserInList(user, this.selectedTeamManagers);
          this.updateUserInList(user, this.selectedTeamDevelopers);
          this.updateUserInList(user, this.selectedTeamLeaders);

          // Check if sorted field changed (check from the currently displayed list after update)
          if (this.activeSort && this.activeSort.active && this.activeSort.direction && oldSortValue !== null) {
            const updatedUser = this._teamMemberListOnMode.find((u: any) => u.id === user.id);
            if (updatedUser) {
              const newSortValue = this.getSortValueFromUser(updatedUser);
              if (oldSortValue !== newSortValue) {
                sortFieldChanged = true;
              }
            }
          }
        }
      });

      // Only re-sort if the sorted field actually changed
      if (sortFieldChanged && this._teamMemberListOnMode && this.activeSort) {
        this.sortData(this.activeSort);
      }

      this.loading = false;
      this.statusLoad = false;
    });
  }

  private updateUserInList(user: any, teamList: any[]) {
    const index = _.findIndex(teamList, (obj: any) => obj.id === user.id);
    if (index === -1) return;
    const isLogoutReason = this.checkLogoutReason(user?.logoutReason?.time, user?.lastOnlineAtTz);

    if (user.lastOnlineAtTz != null) {
      teamList[index].lastOnlineAtTz = user.lastOnlineAtTz;
    }
    if (user.lastOnlineAt != null) {
      teamList[index].lastOnlineAt = user.lastOnlineAt;
    }

    // Status logic - check for idle first
    let status: any;
    if (user.logoutReason && isLogoutReason) {
      status = 'auto-logout';
      if (user.logoutReason?.reason === 'timeOrTimezoneChange') {
        teamList[index].logoutReason = {
          reason: 'Time or Timezone Changed.',
          time: moment.utc(user.logoutReason?.time).local().format("YYYY-MM-DD HH:mm:ss")
        };
      }
    } else if (user.isIdle === true) {
      // status = 'idle';
      // Check for idle status from Firebase
      console.log("user.isIdle >> ", this._sharedService.getUserCurrentStatus(user.lastOnlineAtTz, true) == 'online');
      if (this._sharedService.getUserCurrentStatus(user.lastOnlineAtTz, true) == 'online') {
        status = 'idle';
        // Store idleStartTime if available
        if (user.idleStartTime) {
          teamList[index]["idleStartTime"] = user.idleStartTime;
        }
      } else if (this._sharedService.getUserCurrentStatus(user.lastOnlineAtTz, true) != 'online') {
        status = this._sharedService.getUserCurrentStatus(user.lastOnlineAtTz, true);
      }
    } else if (user.lastOnlineAtTz) {
      status = this._sharedService.getUserCurrentStatus(user.lastOnlineAtTz, true);
    } else if (user.lastOnlineAt) {
      status = this._sharedService.getUserCurrentStatus(user.lastOnlineAt, false);
    } else {
      status = 'not-using';
    }

    teamList[index].status = status;

    // AppInfo logic
    if (user.appInfo?.applicationType && user.appInfo?.version) {
      user.appInfo.label = user.appInfo.applicationType.charAt(0).toUpperCase();
      user.appInfo.applicationType =
        user.appInfo.applicationType.charAt(0).toUpperCase() + user.appInfo.applicationType.slice(1);
      teamList[index].appInfo = user.appInfo;
    } else {
      teamList[index].appInfo = status !== 'not-using' ? { version: '4.1.2' } : '';
    }

    // ssRequest logic
    if (user.ssRequest !== true && user.ssRequest !== false && user.ssRequest != null) {
      teamList[index].ssRequest = user.ssRequest.createdAt;
    }
  }

  checkLogoutReason(logoutTime: string, lastActiveTime: string) {
    return moment(logoutTime).isSameOrAfter(moment(lastActiveTime));
  }

  getAll(): AngularFireList<User> {
    return this.usersRef;
  }

  getEmployeeIdOnTeamSelect(metaData: any, users?: any) {
    if (users) {
      this._usersList = users;
    }
    this.selectedAllTeam = [];
    this.selectedTeamManagers = [];
    this.selectedTeamDevelopers = [];
    this.selectedTeamLeaders = [];
    let managers = metaData.team_manager
      .replace("~", "")
      .replace(/~$/, "")
      .replaceAll("~", ",")
      .split(",");
    let developers = metaData.team_developer
      .replace("~", "")
      .replace(/~$/, "")
      .replaceAll("~", ",")
      .split(",");
    let leaders = metaData.team_lead
      .replace("~", "")
      .replace(/~$/, "")
      .replaceAll("~", ",")
      .split(",");

    let obj = {};
    obj["manager"] = managers;
    obj["developer"] = developers;
    obj["leaders"] = leaders;

    this.filteringData(this._usersList, obj);
  }

  filteringData(userList: any, data: any) {
    let onlyUsersId = [];
    let key;
    let uniqeId = [];
    let selectedUser = [];
    for (key in data) {
      data[key].map((ele) => {
        onlyUsersId.push(ele);
      });
    }
    uniqeId = Array.from(new Set(onlyUsersId));

    uniqeId.map((ele) => {
      userList.filter((userId) => {
        if (parseInt(ele) == parseInt(userId.id)) {
          selectedUser.push(userId);
        }
      });
    });

    for (key in data) {
      switch (key) {
        case "manager":
          data[key].map((ele) => {
            return selectedUser.filter((element) => {
              if (element.id == ele) {
                this.selectedTeamManagers.push(element);
                if (!this.selectedAllTeam.find(u => u.id === element.id)) {
                  element.teamRole = 'manager';
                  this.selectedAllTeam.push(element);
                }
              }
            });
          });
          break;
        case "developer":
          data[key].map((ele) => {
            return selectedUser.filter((element) => {
              if (element.id == ele) {
                this.selectedTeamDevelopers.push(element);
                if (!this.selectedAllTeam.find(u => u.id === element.id)) {
                  element.teamRole = 'employee';
                  this.selectedAllTeam.push(element);
                }
              }
            });
          });
          break;
        case "leaders":
          data[key].map((ele) => {
            return selectedUser.filter((element) => {
              if (element.id == ele) {
                this.selectedTeamLeaders.push(element);
                if (!this.selectedAllTeam.find(u => u.id === element.id)) {
                  element.teamRole = 'lead';
                  this.selectedAllTeam.push(element);
                }
              }
            });
          });
          break;
      }
    }
  }

  getRoleMembers(role) {
    if (role == 'manager') {
      this.historyTabs = 1;
      this._teamMemberListOnMode = this.selectedTeamManagers;
    } else if (role == 'leaders') {
      this.historyTabs = 2;
      this._teamMemberListOnMode = this.selectedTeamLeaders;
    } else if (role == 'developer') {
      this.historyTabs = 3;
      this._teamMemberListOnMode = this.selectedTeamDevelopers;
    } else {
      this.historyTabs = 0;
      this._teamMemberListOnMode = this.selectedAllTeam;
    }

    // Re-apply sort if active
    if (this.activeSort && this.activeSort.active && this.activeSort.direction) {
      this.sortData(this.activeSort);
    }
  }

  teamRoleSelect(role) {
    this.selectedManagr = role;
    let displayRole = role;

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { selectedRole: displayRole },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  sortData(sort: Sort) {
    console.log("sort data: ", sort);
    this.activeSort = sort; // Store the sort state

    if (this._teamMemberListOnMode.length > 0) {
      const data = this._teamMemberListOnMode.slice();
      if (!sort.active || sort.direction === "") {
        this._teamMemberListOnMode = data;
        return;
      }

      const sortedData = data.sort((a, b) => {
        const isAsc = sort.direction === "asc";
        switch (sort.active) {
          case "Employee Name":
            return this.compare(a.name.toLowerCase(), b.name.toLowerCase(), isAsc);
          case "status":
            const statusA: any = this.getStatusValue(a);
            const statusB: any = this.getStatusValue(b);
            return this.compare(statusA, statusB, isAsc);
          case 'screenshot':
            return this.compare(b.meta.last_ss, a.meta.last_ss, isAsc);
          case 'usedApps':
            console.log("")
            return this.compare(a.meta.last_application_name.toLowerCase(), b.meta.last_application_name.toLowerCase(), isAsc);
          case 'appInfo':
            const compareValue = this.getCompareValueOnVersion(a, b);
            return this.compare(compareValue[0], compareValue[1], isAsc);
          case 'role':
            return this.compare(a.role.length > 1 ? a.role[1] : a.role[0], b.role.length > 1 ? b.role[1] : b.role[0], isAsc);
          default:
            return 0;
        }
      });

      this._teamMemberListOnMode = sortedData;
      console.log("all users and developerList: ", sortedData, this._teamMemberListOnMode)
    }
  }

  private getSortValueFromUser(user: any): any {
    if (!this.activeSort || !this.activeSort.active || !user) return null;

    switch (this.activeSort.active) {
      case "Employee Name":
        return user.name;
      case "status":
        return this.getStatusValue(user);
      case 'screenshot':
        return user.meta?.last_ss || '';
      case 'usedApps':
        return user.meta?.last_application_name?.toLowerCase() || '';
      case 'appInfo':
        const compareValue = this.getCompareValueOnVersion(user, {});
        return compareValue[0] || '';
      case 'role':
        return user.role && user.role.length > 1 ? user.role[1] : (user.role && user.role.length > 0 ? user.role[0] : '');
      default:
        return null;
    }
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getStatusValue(user) {

    if (!user.status) {
      return '4-invite';
    }
    if (user.status === 'not-using') {
      return '4-invite';
    }

    if (user.status === 'online') {
      return '6-online';
    }

    if (user.status === 'auto-logout') {
      return '2-auto-logout';
    }

    if (user.status === 'idle') {
      return '3-idle';
    }


    if (this._sharedService.getDayDifferenceForAbsent(user.status) > 0) {
      return '1-absent';
    } else {
      return '5-offline';
    }


    // if (user.status == "online") {
    //   console.log('user--', user.status)
    //   return 'online';
    // } else if (user.status == "auto-logout") {
    //   return 'auto-logout';
    // }
    // else if (!user.status) {
    //   return 'invite';
    // } else {
    //   return 'offline';
    // }
  }

  getCompareValueOnVersion(compareValueOne, compareValueTwo) {
    let compareValue = [];
    if (compareValueOne.appInfo) {
      let value = compareValueOne.appInfo?.applicationType ? `${compareValueOne.appInfo?.version}" "${compareValueOne.appInfo?.applicationType}` : `${compareValueOne.appInfo?.version}`
      compareValue.push(value);
    } else {
      compareValue.push("");
    }
    if (compareValueTwo.appInfo) {
      let value = compareValueTwo.appInfo?.applicationType ? `${compareValueTwo.appInfo?.version}" "${compareValueTwo.appInfo?.applicationType}` : `${compareValueTwo.appInfo?.version}`
      compareValue.push(value);
    } else {
      compareValue.push("");
    }

    return compareValue;
  }

  private enrichDummyUsers(users: any[]): any[] {
    if (!Array.isArray(users)) return [];
    const applications = [
      'Google Chrome', 'Visual Studio Code', 'Discord', 'Windows Explorer', 'Slack',
      'Figma', 'Outlook', 'Microsoft Teams', 'Edge', 'Terminal'
    ];
    const osPool = [
      { applicationType: 'Windows', label: 'W' },
      { applicationType: 'Mac', label: 'M' },
      { applicationType: 'Linux', label: 'L' },
    ];
    const usedMinuteOffsets = new Set<number>();
    const getUniqueMinutesAgo = (): number => {
      let minutes = 0;
      let tries = 0;
      // 5 minutes to 2 hours (120 minutes)
      do {
        minutes = 5 + Math.floor(Math.random() * (120 - 5 + 1));
        tries++;
      } while (usedMinuteOffsets.has(minutes) && tries < 50);
      usedMinuteOffsets.add(minutes);
      return minutes;
    };
    const shuffledApps = [...applications].sort(() => Math.random() - 0.5);
    return users.map((user: any, index: number) => {
      const minutesAgo = getUniqueMinutesAgo();
      const lastScreenshot = new Date(Date.now() - minutesAgo * 60 * 1000).toISOString();
      const appName = shuffledApps[index % shuffledApps.length];
      const os = osPool[index % osPool.length];
      const version = `4.${1 + Math.floor(Math.random() * 5)}.${Math.floor(Math.random() * 10)}`;
      const meta = {
        ...(user.meta || {}),
        last_screenshot: user.meta?.last_screenshot || lastScreenshot,
        last_application_name: user.meta?.last_application_name || appName
      };
      const appInfo = user.appInfo || { version, applicationType: os.applicationType, label: os.label };
      return { ...user, status: 'online', meta, appInfo };
    });
  }

}
